export enum UITextWhitespace {
    normal,
    nowrap,
    pre,
    preLine,
    preWrap
}